import { render, staticRenderFns } from "./InformasiLainnya-Desktop.vue?vue&type=template&id=035c623b&scoped=true&"
import script from "./InformasiLainnya-Desktop.vue?vue&type=script&lang=js&"
export * from "./InformasiLainnya-Desktop.vue?vue&type=script&lang=js&"
import style0 from "./InformasiLainnya-Desktop.vue?vue&type=style&index=0&id=035c623b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035c623b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
